<template>
  <div :class="['section-header-component', between ? 'between' : '']">
    <div class="section-left">
      <div class="circle"></div>
      <div class="s-title">{{ title }}</div>
      <slot name="left"></slot>
    </div>
    <div class="section-right">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SectionHeader',
  props: {
    title: {
      type: String,
      default: ''
    },
    between: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.section-header-component {
  @include flexS;
  margin-bottom: 16px;
  color: #333;
  /deep/ .el-button--text {
    padding-top: 4px;
    padding-bottom: 4px;
  }
  &.between {
    justify-content: space-between;
  }
  .section-left {
    @include flexS;
    .circle {
      width: 7px;
      height: 7px;
      background-color: $subjectColor;
      border-radius: 50%;
      margin-right: 10px;
    }
    .s-title {
      font-weight: bold;
    }
  }
  .section-right {
    @include flex-fixed;
    @include flexS;
    margin-left: 20px;
  }
}
</style>
